import { Measure } from "../models/measure";
import { httpGet } from "./http-client";

const apiUrl = '/api/measures';

export const getMeasures = () => httpGet<Measure[]>(apiUrl);
